import React from "react";

const Social = () => {
  return (
    <div className="home_social">
      <a href="https://github.com/supriya1011" className="home_social-icon" target="_blank" rel="noreferrer">
        <i className="uil uil-github"></i>
      </a>

      <a href="https://www.linkedin.com/in/supriya-sahoo/" className="home_social-icon" target="_blank" rel="noreferrer">
        <i className="uil uil-linkedin"></i>
      </a>

      <a href="https://twitter.com/SupriyoSahoo3" className="home_social-icon" target="_blank" rel="noreferrer">
        <i className="uil uil-twitter"></i>
      </a>
    </div>
  );
};

export default Social;